// extracted by mini-css-extract-plugin
export default {"content":"Insights_content__g21Hn","card-wpapper":"Insights_card-wpapper__+1s9s"};